module.exports = __webpack_public_path__ + "img/lx_wsyl.cbd0b4da.svg";